import { gql } from '@apollo/client';

export const ALL_FUNDER_MYFORMS = gql`
  query AllFunderMyForms {
    forms: funderMyForms {
      createdAt
      updatedAt
      id
      name
      type
      monitoringForm {
        id
        name
        programme {
          id
          name
        }
      }
      template {
        id
        name
      }
    }
  }
`;
